import type { ElementMessage } from '../../types'

interface ElementMessageListProps {
  messageList: ElementMessage[]
  activeMessageId: string | null
  isMessagesLoading: boolean
  onMessageSelect: (message: ElementMessage) => void
}

function formatElementMessageTimestamp(receivedAtTimestamp: string): string {
  const messageDate = new Date(receivedAtTimestamp)
  const todayDate = new Date()
  const isReceivedToday = messageDate.toDateString() === todayDate.toDateString()
  return isReceivedToday
    ? messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : messageDate.toLocaleDateString([], { month: 'short', day: 'numeric' })
}

export function ElementMessageList({
  messageList,
  activeMessageId,
  isMessagesLoading,
  onMessageSelect
}: ElementMessageListProps) {
  if (isMessagesLoading) {
    return (
      <div className="element-message-list-loading">
        <div className="element-loading-indicator">Loading messages...</div>
      </div>
    )
  }

  if (!messageList.length) {
    return (
      <div className="element-message-list-empty">
        <span className="element-empty-icon">◈</span>
        <p className="element-empty-label">No messages here</p>
      </div>
    )
  }

  return (
    <div className="element-message-list">
      {messageList.map(elementMessage => (
        <button
          key={elementMessage.id}
          className={[
            'element-message-list-item',
            elementMessage.is_read === 0 ? 'element-message-list-item--unread' : '',
            elementMessage.is_starred === 1 ? 'element-message-list-item--starred' : '',
            elementMessage.spam_score >= 0.8 ? 'element-message-list-item--spam' : '',
            activeMessageId === elementMessage.id ? 'element-message-list-item--active' : ''
          ].filter(Boolean).join(' ')}
          onClick={() => onMessageSelect(elementMessage)}
        >
          <div className="element-message-item-header">
            <span className="element-message-sender">
              {elementMessage.from_name || elementMessage.from_address}
            </span>
            <span className="element-message-timestamp">
              {formatElementMessageTimestamp(elementMessage.received_at)}
            </span>
          </div>
          <div className="element-message-subject">
            {elementMessage.subject || '(no subject)'}
          </div>
          {elementMessage.has_attachments === 1 && (
            <span className="element-attachment-indicator">⊕ attachment</span>
          )}
        </button>
      ))}
    </div>
  )
}
